import FixedPlugin from './FixedPlugin.jsx';
import enhance from './FixedPlugin.enhancer';

export default enhance(FixedPlugin);
